import { useNavigate } from 'react-router-dom';

import useTranslations from '@/i18n/useTranslations';
import { createCommunityArtworkNavigationState } from '@/shared/lib/communityArtworkNavigation';
import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';
import UserProfileImage from '@/shared-components/cards/components/UserProfileImage';
import Text from '@/shared-components/text/components/Text';
import TextHandler from '@/shared-components/text/components/TextHandler';
import Utils from '@/utils';
import { hasRenderableThought } from '@/utils/activityContent';

import './styles/CommunityThoughtCard.css';

export default function CommunityThoughtCard({ data, actor, showDate = true }) {
  const navigate = useNavigate();
  const t = useTranslations('common.shared.community_feed');
  if (!hasRenderableThought(data)) {
    return null;
  }
  return (
    <>
      <div
        className="community-thought-card__container"
        onClick={() =>
          navigate(`/artwork/${data.thought_artwork.slug}?thought=${data._id}`, {
            state: createCommunityArtworkNavigationState(),
          })
        }
      >
        <div className="community-thought-card__header">
          <UserProfileImage
            image={actor?.image}
            typeOfProfile={actor?.profileType}
            className="community-thought-card__user-image"
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/user/${actor?.username}`);
            }}
          />

          <div className="community-thought-card__header-text">
            <Text
              className="community-thought-card__username"
              paragraph
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/user/${actor?.username}`);
              }}>
              {actor?.username}
            </Text>
            <Text className="community-thought-card__small-text" paragraph>
              {t('activity.thought')}{' '}

              <span className="community-thought-card__artwork-title">
                {data.thought_artwork.artwork_about.artwork_title}
              </span>
            </Text>

          </div>

          {showDate && (
            <Text className="community-thought-card__timestamp" paragraph>
              {Utils.elapsedTime(new Date(data.createdAt).getTime())}
            </Text>
          )}  
        </div>
        <TextHandler
          moreControlClick={() => {}}
          className="community-thought-card__thought-text-container"
          maxLinesWhenCollapsed={5}
          maxCharactersWhenCollapsed={400}
          controlsClassName="community-thought-card__thought-text-controls"
          text={data.thought_message} />

        <ArtworkImage
          image={data.thought_artwork.artwork_media.artwork_main_picture.image_id}
          imageClassName="community-thought-card__thought-image"
          imageTemplateClassName="community-thought-card__thought-image"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/artwork/${data.thought_artwork.slug}`, {
              state: createCommunityArtworkNavigationState(),
            });
          }}
          forceSmaller={300}
        />
      </div>
    </>
  );
}
